/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions, FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON, } from './FxIdApplicationPublicDataBuilderFxLauncherOptions';
export function FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(json)) {
        return FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(value)) {
        return FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseFxLauncherOptions.js.map